(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}

jQuery(document).ready(function ($) {
  var dateSalvate = getCookie('date_salvate');
  var nume = getCookie('nume');
  var prenume = getCookie('prenume');
  var telefon = getCookie('telefon');
  var adresa = getCookie('adresa');
  var email = getCookie('email');

  if (dateSalvate != '' && dateSalvate == 'true') {
    jQuery('#my_checkbox').prop('checked', true);
    jQuery('#billing_first_name').val(nume.replace(/,/g, " "));
    jQuery('#billing_last_name').val(prenume.replace(/,/g, " "));
    jQuery('#billing_address_1').val(adresa.replace(/,/g, " "));
    jQuery('#billing_phone').val(telefon.replace(/,/g, " "));
    jQuery('#billing_email').val(email.replace(/,/g, " "));
    jQuery('#account_username').val(email.replace(/,/g, " "));
  } else {
    jQuery('#billing_first_name').val('');
    jQuery('#billing_last_name').val('');
    jQuery('#billing_address_1').val('');
    jQuery('#billing_phone').val('');
    jQuery('#billing_email').val('');
    jQuery('#account_username').val('');
  }
});

},{}]},{},[1]);
